module.exports = __webpack_public_path__ + "img/ResourceDownload2.b1cd98dd.png";